import { isEqual } from "lodash-es"

export const getObjectDiff = (obj1: object, obj2: object) => {
  return Object.keys(obj2).reduce((result, key) => {
    if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
      result.push(key)
    } else if (isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key)
      result.splice(resultKeyIndex, 1)
    }
    return result
  }, Object.keys(obj2))
}

export const removeFalsyProperties = <T extends Record<string, unknown>>(
  obj: T,
): Partial<T> => {
  return Object.keys(obj).reduce((result: Partial<T>, key: keyof T) => {
    if (obj[key] !== undefined && obj[key] !== "") {
      result[key] = obj[key]
    }
    return result
  }, {} as Partial<T>)
}

export function safeNumber(value: string | number | undefined | null) {
  const number = Number(value)
  if ((!value && value !== 0) || isNaN(number)) return undefined
  return number
}

// Use when updating cache to ensure reactivity
export const cloneInstance = <T>(obj: T): T =>
  Object.create(
    Object.getPrototypeOf(obj),
    Object.getOwnPropertyDescriptors(obj),
  )

export const isEmpty = (val) => {
  return (
    val === null ||
    val === undefined ||
    val === "" ||
    (typeof val === "object" && Object.keys(val).length === 0) ||
    (Array.isArray(val) && val.length === 0)
  )
}
